import { Transaction } from "@mysten/sui/transactions";
import { coinsList } from "../common/coins.js";
import { bluefinPoolMap, cetusPoolMap, loopingAccountAddresses, naviAssetMap, naviPriceFeedMap, poolInfo, singleAssetPoolCoinMap, } from "../common/maps.js";
import { getReceipts } from "../sui-sdk/functions/getReceipts.js";
import { getConf } from "../common/constants.js";
import { getSuiClient } from "../sui-sdk/client.js";
import { updateSingleTokenPrice } from "./naviOracle.js";
import { getAvailableRewards } from "./get_navi_rewards.js";
export async function naviDepositTx(amount, poolName, options) {
    const C = getConf();
    const suiClient = getSuiClient();
    const address = options.address;
    const txb = new Transaction();
    poolName = poolName.toUpperCase();
    const poolData = poolInfo[poolName];
    const receipt = await getReceipts(poolName, address, true);
    await updateSingleTokenPrice(getSuiClient(), naviPriceFeedMap[singleAssetPoolCoinMap[poolName].coin].pythPriceInfo, naviPriceFeedMap[singleAssetPoolCoinMap[poolName].coin].feedId, txb);
    if (singleAssetPoolCoinMap[poolName].coin == "SUI") {
        let someReceipt;
        if (receipt.length == 0) {
            [someReceipt] = txb.moveCall({
                target: `0x1::option::none`,
                typeArguments: [poolData.receiptType],
                arguments: [],
            });
        }
        else {
            [someReceipt] = txb.moveCall({
                target: `0x1::option::some`,
                typeArguments: [receipt[0].content.type],
                arguments: [txb.object(receipt[0].objectId)],
            });
        }
        const [depositCoin] = txb.splitCoins(txb.gas, [amount]);
        const claimableRewards = await getAvailableRewards(getConf().NAVI_SUI_ACCOUNT_ADDRESS);
        if (claimableRewards) {
            for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                : []) {
                if (reward.rewardCoinType === coinsList["NAVX"].type) {
                    txb.moveCall({
                        target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_one_swap_bluefin`,
                        typeArguments: [
                            coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                            coinsList["NAVX"].type,
                        ],
                        arguments: [
                            txb.object(poolData.investorId),
                            txb.object(C.VERSION),
                            txb.object(C.CLOCK_PACKAGE_ID),
                            txb.object(C.NAVI_STORAGE),
                            txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                            txb.object(C.NAVI_INCENTIVE_V3),
                            txb.object(C.NAVI_NAVX_REWARDS_POOL),
                            txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                            txb.object(bluefinPoolMap["NAVX-SUI"]),
                        ],
                    });
                }
                else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                    txb.moveCall({
                        target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_one_swap`,
                        typeArguments: [
                            coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                            coinsList["VSUI"].type,
                        ],
                        arguments: [
                            txb.object(poolData.investorId),
                            txb.object(C.VERSION),
                            txb.object(C.CLOCK_PACKAGE_ID),
                            txb.object(C.NAVI_STORAGE),
                            txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                            txb.object(C.NAVI_INCENTIVE_V3),
                            txb.object(C.NAVI_VSUI_REWARDS_POOL),
                            txb.object(cetusPoolMap["VSUI-SUI"]),
                            txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                        ],
                    });
                }
            }
        }
        txb.moveCall({
            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_deposit`,
            typeArguments: [coinsList[singleAssetPoolCoinMap[poolName].coin].type],
            arguments: [
                txb.object(C.VERSION),
                someReceipt,
                txb.object(poolData.poolId),
                depositCoin,
                txb.object(poolData.investorId),
                txb.object(C.ALPHA_DISTRIBUTOR),
                txb.object(C.PRICE_ORACLE),
                txb.object(C.NAVI_STORAGE),
                txb.object(poolData.parentPoolId),
                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                txb.object(C.NAVI_INCENTIVE_V3),
                txb.object(C.NAVI_INCENTIVE_V2),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
    }
    else {
        let coins = [];
        let currentCursor = null;
        do {
            const response = await suiClient.getCoins({
                owner: address,
                coinType: coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                cursor: currentCursor,
            });
            coins = coins.concat(response.data);
            // Check if there's a next page
            if (response.hasNextPage && response.nextCursor) {
                currentCursor = response.nextCursor;
            }
            else {
                // No more pages available
                // console.log("No more receipts available.");
                break;
            }
        } while (true);
        if (coins.length >= 1) {
            const [coin] = txb.splitCoins(txb.object(coins[0].coinObjectId), [0]);
            txb.mergeCoins(coin, coins.map((c) => c.coinObjectId));
            const [depositCoin] = txb.splitCoins(coin, [amount]);
            let someReceipt;
            if (receipt.length == 0) {
                [someReceipt] = txb.moveCall({
                    target: `0x1::option::none`,
                    typeArguments: [poolData.receiptType],
                    arguments: [],
                });
            }
            else {
                [someReceipt] = txb.moveCall({
                    target: `0x1::option::some`,
                    typeArguments: [receipt[0].content.type],
                    arguments: [txb.object(receipt[0].objectId)],
                });
            }
            if (singleAssetPoolCoinMap[poolName].coin == "VSUI") {
                const claimableRewards = await getAvailableRewards(getConf().NAVI_VSUI_ACCOUNT_ADDRESS);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        : []) {
                        if (reward.rewardCoinType === coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_two_swaps_bluefin`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                    coinsList["SUI"].type,
                                    coinsList["NAVX"].type,
                                ],
                                arguments: [
                                    txb.object(poolData.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(bluefinPoolMap["NAVX-SUI"]),
                                    txb.object(bluefinPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_no_swap`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                ],
                                arguments: [
                                    txb.object(poolData.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_deposit`,
                    typeArguments: [
                        coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (singleAssetPoolCoinMap[poolName].coin == "WETH" ||
                singleAssetPoolCoinMap[poolName].coin == "USDT") {
                const claimableRewards = await getAvailableRewards(loopingAccountAddresses[poolName]);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        : []) {
                        if (reward.rewardCoinType === coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_three_swaps`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                    coinsList["WUSDC"].type,
                                    coinsList["SUI"].type,
                                    coinsList["NAVX"].type,
                                ],
                                arguments: [
                                    txb.object(poolData.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(cetusPoolMap["NAVX-SUI"]),
                                    txb.object(cetusPoolMap["WUSDC-SUI"]),
                                    txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-WUSDC`]),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_three_swaps`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                    coinsList["WUSDC"].type,
                                    coinsList["SUI"].type,
                                    coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(poolData.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(cetusPoolMap["VSUI-SUI"]),
                                    txb.object(cetusPoolMap["WUSDC-SUI"]),
                                    txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-WUSDC`]),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_deposit`,
                    typeArguments: [
                        coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (singleAssetPoolCoinMap[poolName].coin == "WUSDC") {
                const claimableRewards = await getAvailableRewards(loopingAccountAddresses[poolName]);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        : []) {
                        if (reward.rewardCoinType === coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_two_swaps_bluefin`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                    coinsList["USDC"].type,
                                    coinsList["NAVX"].type,
                                ],
                                arguments: [
                                    txb.object(poolData.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(bluefinPoolMap["NAVX-USDC"]),
                                    txb.object(bluefinPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-USDC`]),
                                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_two_swaps_bluefin_v2`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                    coinsList["USDC"].type,
                                    coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(poolData.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(bluefinPoolMap["VSUI-USDC"]),
                                    txb.object(bluefinPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-USDC`]),
                                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_deposit`,
                    typeArguments: [
                        coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (singleAssetPoolCoinMap[poolName].coin == "USDC") {
                const claimableRewards = await getAvailableRewards(loopingAccountAddresses[poolName]);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        : []) {
                        if (reward.rewardCoinType === coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_two_swaps`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                    coinsList["SUI"].type,
                                    coinsList["NAVX"].type,
                                ],
                                arguments: [
                                    txb.object(poolData.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(cetusPoolMap["NAVX-SUI"]),
                                    txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_two_swaps`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                    coinsList["SUI"].type,
                                    coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(poolData.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(cetusPoolMap["VSUI-SUI"]),
                                    txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_deposit`,
                    typeArguments: [
                        coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (singleAssetPoolCoinMap[poolName].coin == "USDY") {
                const claimableRewards = await getAvailableRewards(loopingAccountAddresses[poolName]);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        : []) {
                        if (reward.rewardCoinType === coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_three_swaps`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                    coinsList["WUSDC"].type,
                                    coinsList["SUI"].type,
                                    coinsList["NAVX"].type,
                                ],
                                arguments: [
                                    txb.object(poolData.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(cetusPoolMap["NAVX-SUI"]),
                                    txb.object(cetusPoolMap["WUSDC-SUI"]),
                                    txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-WUSDC`]),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_three_swaps`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                    coinsList["WUSDC"].type,
                                    coinsList["SUI"].type,
                                    coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(poolData.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(cetusPoolMap["VSUI-SUI"]),
                                    txb.object(cetusPoolMap["WUSDC-SUI"]),
                                    txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-WUSDC`]),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_deposit`,
                    typeArguments: [
                        coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (singleAssetPoolCoinMap[poolName].coin == "AUSD" ||
                singleAssetPoolCoinMap[poolName].coin == "ETH") {
                const claimableRewards = await getAvailableRewards(loopingAccountAddresses[poolName]);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        : []) {
                        if (reward.rewardCoinType === coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_three_swaps_bluefin`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                    coinsList["USDC"].type,
                                    coinsList["SUI"].type,
                                    coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    txb.object(cetusPoolMap["VSUI-SUI"]),
                                    txb.object(cetusPoolMap["USDC-SUI"]),
                                    txb.object(bluefinPoolMap[`USDC-${singleAssetPoolCoinMap[poolName].coin}`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_deposit`,
                    typeArguments: [
                        coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "NAVI-NS") {
                const claimableRewards = await getAvailableRewards(getConf().NAVI_NS_ACCOUNT_ADDRESS);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        : []) {
                        if (reward.rewardCoinType === coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                    coinsList["NAVX"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    txb.object(cetusPoolMap["NAVX-SUI"]),
                                    txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coinsList["DEEP"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                    coinsList["DEEP"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_DEEP_REWARDS_POOL),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    txb.object(cetusPoolMap["DEEP-SUI"]),
                                    txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                    coinsList["SUI"].type,
                                    coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    txb.object(cetusPoolMap["VSUI-SUI"]),
                                    txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coinsList["NS"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NS_REWARDS_POOL),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool_with_two_swaps_v2`,
                    typeArguments: [
                        coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                        coinsList["SUI"].type,
                        coinsList["VSUI"].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(poolData.poolId),
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V1),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.NAVI_VSUI_FUNDS_POOL),
                        txb.object(C.NAVI_NS_FUNDS_POOL),
                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                        txb.object(cetusPoolMap["VSUI-SUI"]),
                        txb.object(cetusPoolMap["NS-SUI"]),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_deposit`,
                    typeArguments: [
                        coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "NAVI-NAVX") {
                const claimableRewards = await getAvailableRewards(getConf().NAVI_NAVX_ACCOUNT_ADDRESS);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        : []) {
                        if (reward.rewardCoinType === coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                    coinsList["SUI"].type,
                                    coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    txb.object(cetusPoolMap["VSUI-SUI"]),
                                    txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool_with_two_swaps_v2`,
                    typeArguments: [
                        coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                        coinsList["SUI"].type,
                        coinsList["VSUI"].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(poolData.poolId),
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V1),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.NAVI_VSUI_FUNDS_POOL),
                        txb.object(C.NAVI_NAVX_FUNDS_POOL),
                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                        txb.object(cetusPoolMap["VSUI-SUI"]),
                        txb.object(cetusPoolMap["NAVX-SUI"]),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_deposit`,
                    typeArguments: [
                        coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "NAVI-STSUI") {
                const claimableRewards = await getAvailableRewards(getConf().NAVI_STSUI_ACCOUNT_ADDRESS);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        : []) {
                        if (reward.rewardCoinType === coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                    coinsList["SUI"].type,
                                    coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    txb.object(cetusPoolMap["VSUI-SUI"]),
                                    txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coinsList["STSUI"].type) {
                            txb.moveCall({
                                target: `${poolData.packageId}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                                typeArguments: [coinsList["STSUI"].type],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_STSUI_REWARDS_POOL),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool_with_two_swaps_v2`,
                    typeArguments: [
                        coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                        coinsList["SUI"].type,
                        coinsList["VSUI"].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(poolData.poolId),
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V1),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.NAVI_VSUI_FUNDS_POOL),
                        txb.object(C.NAVI_STSUI_FUNDS_POOL),
                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                        txb.object(cetusPoolMap["VSUI-SUI"]),
                        txb.object(cetusPoolMap["STSUI-SUI"]),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_deposit`,
                    typeArguments: [
                        coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "NAVI-SUIBTC") {
                const claimableRewards = await getAvailableRewards(getConf().NAVI_SUIBTC_ACCOUNT_ADDRESS);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        : []) {
                        if (reward.rewardCoinType === coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_NAVI_V2_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps_bluefin`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                    coinsList["SUI"].type,
                                    coinsList["NAVX"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_NAVI_V2_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                    txb.object(bluefinPoolMap["NAVX-SUI"]),
                                    txb.object(bluefinPoolMap[`SUI-${singleAssetPoolCoinMap[poolName].coin}`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coinsList["DEEP"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_NAVI_V2_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps_bluefin`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                    coinsList["SUI"].type,
                                    coinsList["DEEP"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_NAVI_V2_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_DEEP_REWARDS_POOL),
                                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                    txb.object(bluefinPoolMap["DEEP-SUI"]),
                                    txb.object(bluefinPoolMap[`SUI-${singleAssetPoolCoinMap[poolName].coin}`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_NAVI_V2_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps_bluefin`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                    coinsList["SUI"].type,
                                    coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_NAVI_V2_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                    txb.object(bluefinPoolMap["VSUI-SUI"]),
                                    txb.object(bluefinPoolMap[`SUI-${singleAssetPoolCoinMap[poolName].coin}`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_NAVI_V2_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool`,
                    typeArguments: [
                        coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                        coinsList["VSUI"].type,
                        coinsList["NAVX"].type,
                        coinsList["DEEP"].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_NAVI_V2_VERSION),
                        txb.object(poolData.poolId),
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.CLOCK_PACKAGE_ID),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V1),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.NAVI_VSUI_FUNDS_POOL),
                        txb.object(C.NAVI_NAVX_FUNDS_POOL),
                        txb.object(C.NAVI_DEEP_FUNDS_POOL),
                        txb.object(bluefinPoolMap["VSUI-SUI"]),
                        txb.object(cetusPoolMap["NAVX-SUI"]),
                        txb.object(bluefinPoolMap["DEEP-SUI"]),
                        txb.object(bluefinPoolMap["SUI-SUIBTC"]),
                        txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    ],
                });
                txb.moveCall({
                    target: `${C.ALPHA_NAVI_V2_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_deposit_v2`,
                    typeArguments: [
                        coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_NAVI_V2_VERSION),
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "NAVI-SUIUSDT") {
                const claimableRewards = await getAvailableRewards(getConf().NAVI_SUIUSDT_ACCOUNT_ADDRESS);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        : []) {
                        if (reward.rewardCoinType === coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_three_swaps`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                    coinsList["USDC"].type,
                                    coinsList["SUI"].type,
                                    coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    txb.object(cetusPoolMap["VSUI-SUI"]),
                                    txb.object(cetusPoolMap["USDC-SUI"]),
                                    txb.object(cetusPoolMap[`USDC-${singleAssetPoolCoinMap[poolName].coin}`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_deposit`,
                    typeArguments: [
                        coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (singleAssetPoolCoinMap[poolName].coin == "WAL") {
                const claimableRewards = await getAvailableRewards(loopingAccountAddresses[poolName]);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        : [
                            { rewardCoinType: coinsList["WAL"].type },
                            { rewardCoinType: coinsList["VSUI"].type },
                        ]) {
                        if (reward.rewardCoinType === coinsList["WAL"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_WAL_REWARDS_POOL),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps_bluefin`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                    coinsList["SUI"].type,
                                    coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                    txb.object(bluefinPoolMap["VSUI-SUI"]),
                                    txb.object(bluefinPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_deposit`,
                    typeArguments: [
                        coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (singleAssetPoolCoinMap[poolName].coin == "DEEP") {
                const claimableRewards = await getAvailableRewards(loopingAccountAddresses[poolName]);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                        : []) {
                        if (reward.rewardCoinType === coinsList["DEEP"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_DEEP_REWARDS_POOL),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps_bluefin`,
                                typeArguments: [
                                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                    coinsList["SUI"].type,
                                    coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                    txb.object(bluefinPoolMap["VSUI-SUI"]),
                                    txb.object(bluefinPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_deposit`,
                    typeArguments: [
                        coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else {
                txb.moveCall({
                    target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_deposit_with_two_swaps`,
                    typeArguments: [
                        coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                        coinsList["SUI"].type,
                        coinsList["VSUI"].type,
                    ],
                    arguments: [
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V1),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.NAVI_VSUI_FUNDS_POOL),
                        txb.object(C.NAVI_VSUI_FUNDS_POOL),
                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                        txb.object(cetusPoolMap["VSUI-SUI"]),
                        txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            txb.transferObjects([coin], address);
        }
        else {
            throw new Error(`No ${singleAssetPoolCoinMap[poolName].coin} Coins`);
        }
    }
    return txb;
}
export async function naviWithdrawTx(xTokens, poolName, options) {
    const C = await getConf();
    const address = options.address;
    const txb = new Transaction();
    poolName = poolName.toUpperCase();
    const poolData = poolInfo[poolName];
    const receipt = await getReceipts(poolName, address, true);
    const alphaReceipt = await getReceipts("ALPHA", address, true);
    if (receipt.length > 0) {
        let alpha_receipt;
        if (alphaReceipt.length == 0) {
            [alpha_receipt] = txb.moveCall({
                target: `0x1::option::none`,
                typeArguments: [C.ALPHA_POOL_RECEIPT],
                arguments: [],
            });
        }
        else {
            [alpha_receipt] = txb.moveCall({
                target: `0x1::option::some`,
                typeArguments: [alphaReceipt[0].content.type],
                arguments: [txb.object(alphaReceipt[0].objectId)],
            });
        }
        await updateSingleTokenPrice(getSuiClient(), naviPriceFeedMap[singleAssetPoolCoinMap[poolName].coin].pythPriceInfo, naviPriceFeedMap[singleAssetPoolCoinMap[poolName].coin].feedId, txb);
        if (singleAssetPoolCoinMap[poolName].coin == "SUI") {
            const claimableRewards = await getAvailableRewards(getConf().NAVI_SUI_ACCOUNT_ADDRESS);
            if (claimableRewards) {
                for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coinsList["NAVX"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_one_swap_bluefin`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                coinsList["NAVX"].type,
                            ],
                            arguments: [
                                txb.object(poolData.investorId),
                                txb.object(C.VERSION),
                                txb.object(C.CLOCK_PACKAGE_ID),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                txb.object(bluefinPoolMap["NAVX-SUI"]),
                                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_one_swap`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(poolData.investorId),
                                txb.object(C.VERSION),
                                txb.object(C.CLOCK_PACKAGE_ID),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(cetusPoolMap["VSUI-SUI"]),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_withdraw`,
                typeArguments: [coinsList[singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (singleAssetPoolCoinMap[poolName].coin == "VSUI") {
            const claimableRewards = await getAvailableRewards(getConf().NAVI_VSUI_ACCOUNT_ADDRESS);
            if (claimableRewards) {
                for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coinsList["NAVX"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_two_swaps_bluefin`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                coinsList["SUI"].type,
                                coinsList["NAVX"].type,
                            ],
                            arguments: [
                                txb.object(poolData.investorId),
                                txb.object(C.VERSION),
                                txb.object(C.CLOCK_PACKAGE_ID),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                txb.object(bluefinPoolMap["NAVX-SUI"]),
                                txb.object(bluefinPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_no_swap`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                            ],
                            arguments: [
                                txb.object(poolData.investorId),
                                txb.object(C.VERSION),
                                txb.object(C.CLOCK_PACKAGE_ID),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_withdraw`,
                typeArguments: [coinsList[singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (singleAssetPoolCoinMap[poolName].coin == "WETH" ||
            singleAssetPoolCoinMap[poolName].coin == "USDT") {
            const claimableRewards = await getAvailableRewards(loopingAccountAddresses[poolName]);
            if (claimableRewards) {
                for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coinsList["NAVX"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_three_swaps`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                coinsList["WUSDC"].type,
                                coinsList["SUI"].type,
                                coinsList["NAVX"].type,
                            ],
                            arguments: [
                                txb.object(poolData.investorId),
                                txb.object(C.VERSION),
                                txb.object(C.CLOCK_PACKAGE_ID),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                txb.object(cetusPoolMap["NAVX-SUI"]),
                                txb.object(cetusPoolMap["WUSDC-SUI"]),
                                txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-WUSDC`]),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_three_swaps`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                coinsList["WUSDC"].type,
                                coinsList["SUI"].type,
                                coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(poolData.investorId),
                                txb.object(C.VERSION),
                                txb.object(C.CLOCK_PACKAGE_ID),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(cetusPoolMap["VSUI-SUI"]),
                                txb.object(cetusPoolMap["WUSDC-SUI"]),
                                txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-WUSDC`]),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_withdraw`,
                typeArguments: [coinsList[singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (singleAssetPoolCoinMap[poolName].coin == "WUSDC") {
            const claimableRewards = await getAvailableRewards(loopingAccountAddresses[poolName]);
            if (claimableRewards) {
                for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coinsList["NAVX"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_three_swaps`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                coinsList["CETUS"].type,
                                coinsList["SUI"].type,
                                coinsList["NAVX"].type,
                            ],
                            arguments: [
                                txb.object(poolData.investorId),
                                txb.object(C.VERSION),
                                txb.object(C.CLOCK_PACKAGE_ID),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                txb.object(cetusPoolMap["NAVX-SUI"]),
                                txb.object(cetusPoolMap["CETUS-SUI"]),
                                txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-CETUS`]),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_three_swaps`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                coinsList["CETUS"].type,
                                coinsList["SUI"].type,
                                coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(poolData.investorId),
                                txb.object(C.VERSION),
                                txb.object(C.CLOCK_PACKAGE_ID),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(cetusPoolMap["VSUI-SUI"]),
                                txb.object(cetusPoolMap["CETUS-SUI"]),
                                txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-CETUS`]),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_withdraw`,
                typeArguments: [coinsList[singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (singleAssetPoolCoinMap[poolName].coin == "USDC") {
            const claimableRewards = await getAvailableRewards(loopingAccountAddresses[poolName]);
            if (claimableRewards) {
                for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coinsList["NAVX"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_two_swaps`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                coinsList["SUI"].type,
                                coinsList["NAVX"].type,
                            ],
                            arguments: [
                                txb.object(poolData.investorId),
                                txb.object(C.VERSION),
                                txb.object(C.CLOCK_PACKAGE_ID),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                txb.object(cetusPoolMap["NAVX-SUI"]),
                                txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_two_swaps`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                coinsList["SUI"].type,
                                coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(poolData.investorId),
                                txb.object(C.VERSION),
                                txb.object(C.CLOCK_PACKAGE_ID),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(cetusPoolMap["VSUI-SUI"]),
                                txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_withdraw`,
                typeArguments: [coinsList[singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (singleAssetPoolCoinMap[poolName].coin == "USDY") {
            const claimableRewards = await getAvailableRewards(loopingAccountAddresses[poolName]);
            if (claimableRewards) {
                for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coinsList["NAVX"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_three_swaps`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                coinsList["WUSDC"].type,
                                coinsList["SUI"].type,
                                coinsList["NAVX"].type,
                            ],
                            arguments: [
                                txb.object(poolData.investorId),
                                txb.object(C.VERSION),
                                txb.object(C.CLOCK_PACKAGE_ID),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                txb.object(cetusPoolMap["NAVX-SUI"]),
                                txb.object(cetusPoolMap["WUSDC-SUI"]),
                                txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-WUSDC`]),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_three_swaps`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                coinsList["WUSDC"].type,
                                coinsList["SUI"].type,
                                coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(poolData.investorId),
                                txb.object(C.VERSION),
                                txb.object(C.CLOCK_PACKAGE_ID),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(cetusPoolMap["VSUI-SUI"]),
                                txb.object(cetusPoolMap["WUSDC-SUI"]),
                                txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-WUSDC`]),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_withdraw`,
                typeArguments: [coinsList[singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (singleAssetPoolCoinMap[poolName].coin == "AUSD" ||
            singleAssetPoolCoinMap[poolName].coin == "ETH") {
            const claimableRewards = await getAvailableRewards(loopingAccountAddresses[poolName]);
            if (claimableRewards) {
                for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coinsList["NAVX"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_three_swaps`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                coinsList["USDC"].type,
                                coinsList["SUI"].type,
                                coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                txb.object(cetusPoolMap["VSUI-SUI"]),
                                txb.object(cetusPoolMap["USDC-SUI"]),
                                txb.object(cetusPoolMap[`USDC-${singleAssetPoolCoinMap[poolName].coin}`]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_withdraw`,
                typeArguments: [coinsList[singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.ALPHA_3_VERSION),
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "NAVI-NS") {
            const claimableRewards = await getAvailableRewards(getConf().NAVI_NS_ACCOUNT_ADDRESS);
            if (claimableRewards) {
                for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coinsList["NAVX"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                coinsList["NAVX"].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                txb.object(cetusPoolMap["NAVX-SUI"]),
                                txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coinsList["DEEP"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                coinsList["DEEP"].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_DEEP_REWARDS_POOL),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                txb.object(cetusPoolMap["DEEP-SUI"]),
                                txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                coinsList["SUI"].type,
                                coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                txb.object(cetusPoolMap["VSUI-SUI"]),
                                txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coinsList["NS"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NS_REWARDS_POOL),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool_with_two_swaps_v2`,
                typeArguments: [
                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                    coinsList["SUI"].type,
                    coinsList["VSUI"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_3_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V1),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.NAVI_VSUI_FUNDS_POOL),
                    txb.object(C.NAVI_NS_FUNDS_POOL),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(cetusPoolMap["VSUI-SUI"]),
                    txb.object(cetusPoolMap["NS-SUI"]),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_withdraw`,
                typeArguments: [coinsList[singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.ALPHA_3_VERSION),
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "NAVI-NAVX") {
            const claimableRewards = await getAvailableRewards(getConf().NAVI_NAVX_ACCOUNT_ADDRESS);
            if (claimableRewards) {
                for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coinsList["NAVX"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                coinsList["SUI"].type,
                                coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                txb.object(cetusPoolMap["VSUI-SUI"]),
                                txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool_with_two_swaps_v2`,
                typeArguments: [
                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                    coinsList["SUI"].type,
                    coinsList["VSUI"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_3_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V1),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.NAVI_VSUI_FUNDS_POOL),
                    txb.object(C.NAVI_NAVX_FUNDS_POOL),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(cetusPoolMap["VSUI-SUI"]),
                    txb.object(cetusPoolMap["NAVX-SUI"]),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_withdraw`,
                typeArguments: [coinsList[singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.ALPHA_3_VERSION),
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "NAVI-STSUI") {
            const claimableRewards = await getAvailableRewards(getConf().NAVI_STSUI_ACCOUNT_ADDRESS);
            if (claimableRewards) {
                for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coinsList["NAVX"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                coinsList["SUI"].type,
                                coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                txb.object(cetusPoolMap["VSUI-SUI"]),
                                txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coinsList["STSUI"].type) {
                        txb.moveCall({
                            target: `${poolData.packageId}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                            typeArguments: [coinsList["STSUI"].type],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_STSUI_REWARDS_POOL),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool_with_two_swaps_v2`,
                typeArguments: [
                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                    coinsList["SUI"].type,
                    coinsList["VSUI"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_3_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V1),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.NAVI_VSUI_FUNDS_POOL),
                    txb.object(C.NAVI_STSUI_FUNDS_POOL),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(cetusPoolMap["VSUI-SUI"]),
                    txb.object(cetusPoolMap["STSUI-SUI"]),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_withdraw`,
                typeArguments: [coinsList[singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.ALPHA_3_VERSION),
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "NAVI-SUIBTC") {
            const claimableRewards = await getAvailableRewards(getConf().NAVI_SUIBTC_ACCOUNT_ADDRESS);
            if (claimableRewards) {
                for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coinsList["NAVX"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_NAVI_V2_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps_bluefin`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                coinsList["SUI"].type,
                                coinsList["NAVX"].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_NAVI_V2_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                txb.object(bluefinPoolMap["NAVX-SUI"]),
                                txb.object(bluefinPoolMap[`SUI-${singleAssetPoolCoinMap[poolName].coin}`]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coinsList["DEEP"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_NAVI_V2_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps_bluefin`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                coinsList["SUI"].type,
                                coinsList["DEEP"].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_NAVI_V2_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_DEEP_REWARDS_POOL),
                                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                txb.object(bluefinPoolMap["DEEP-SUI"]),
                                txb.object(bluefinPoolMap[`SUI-${singleAssetPoolCoinMap[poolName].coin}`]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_NAVI_V2_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps_bluefin`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                coinsList["SUI"].type,
                                coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_NAVI_V2_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                txb.object(bluefinPoolMap["VSUI-SUI"]),
                                txb.object(bluefinPoolMap[`SUI-${singleAssetPoolCoinMap[poolName].coin}`]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_NAVI_V2_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool`,
                typeArguments: [
                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                    coinsList["VSUI"].type,
                    coinsList["NAVX"].type,
                    coinsList["DEEP"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_NAVI_V2_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.CLOCK_PACKAGE_ID),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V1),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.NAVI_VSUI_FUNDS_POOL),
                    txb.object(C.NAVI_NAVX_FUNDS_POOL),
                    txb.object(C.NAVI_DEEP_FUNDS_POOL),
                    txb.object(bluefinPoolMap["VSUI-SUI"]),
                    txb.object(cetusPoolMap["NAVX-SUI"]),
                    txb.object(bluefinPoolMap["DEEP-SUI"]),
                    txb.object(bluefinPoolMap["SUI-SUIBTC"]),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                ],
            });
            txb.moveCall({
                target: `${C.ALPHA_NAVI_V2_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_withdraw_v2`,
                typeArguments: [coinsList[singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.ALPHA_NAVI_V2_VERSION),
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "NAVI-SUIUSDT") {
            const claimableRewards = await getAvailableRewards(getConf().NAVI_SUIUSDT_ACCOUNT_ADDRESS);
            if (claimableRewards) {
                for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coinsList["NAVX"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_three_swaps`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                coinsList["USDC"].type,
                                coinsList["SUI"].type,
                                coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                txb.object(cetusPoolMap["VSUI-SUI"]),
                                txb.object(cetusPoolMap["USDC-SUI"]),
                                txb.object(cetusPoolMap[`USDC-${singleAssetPoolCoinMap[poolName].coin}`]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_withdraw`,
                typeArguments: [coinsList[singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.ALPHA_3_VERSION),
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (singleAssetPoolCoinMap[poolName].coin == "WAL") {
            const claimableRewards = await getAvailableRewards(loopingAccountAddresses[poolName]);
            if (claimableRewards) {
                for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    : [
                        { rewardCoinType: coinsList["WAL"].type },
                        { rewardCoinType: coinsList["VSUI"].type },
                    ]) {
                    if (reward.rewardCoinType === coinsList["WAL"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_WAL_REWARDS_POOL),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps_bluefin`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                coinsList["SUI"].type,
                                coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                txb.object(bluefinPoolMap["VSUI-SUI"]),
                                txb.object(bluefinPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_withdraw`,
                typeArguments: [coinsList[singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.ALPHA_3_VERSION),
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (singleAssetPoolCoinMap[poolName].coin == "DEEP") {
            const claimableRewards = await getAvailableRewards(loopingAccountAddresses[poolName]);
            if (claimableRewards) {
                for (const reward of claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coinsList[singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coinsList["DEEP"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_DEEP_REWARDS_POOL),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps_bluefin`,
                            typeArguments: [
                                coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                                coinsList["SUI"].type,
                                coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                txb.object(bluefinPoolMap["VSUI-SUI"]),
                                txb.object(bluefinPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_withdraw`,
                typeArguments: [coinsList[singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.ALPHA_3_VERSION),
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else {
            txb.moveCall({
                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_withdraw_with_two_swaps`,
                typeArguments: [
                    coinsList[singleAssetPoolCoinMap[poolName].coin].type,
                    coinsList["SUI"].type,
                    coinsList["VSUI"].type,
                ],
                arguments: [
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(naviAssetMap[singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V1),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.NAVI_VSUI_FUNDS_POOL),
                    txb.object(C.NAVI_VSUI_FUNDS_POOL),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(cetusPoolMap["VSUI-SUI"]),
                    txb.object(cetusPoolMap[`${singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
    }
    else {
        throw new Error(`No ${poolName} Receipt`);
    }
    return txb;
}
//# sourceMappingURL=navi.js.map